import BulkActions from "../ContactList/BulkActions/BulkActions";
import ContactList from "../ContactList/ContactList";
import Edit from "../ContactList/BulkActions/Edit";
import Filters from "../Filters/Filters";
import PageHeader from "../PageHeader";
import React from 'react';
import TagList from "../Tagging/TagList";
import duckify, { filterDuck } from "../../utils/duckify";
import useBulkActions from "../../hooks/useBulkActions";
import withFiltering from "../../hocs/withFiltering";
import withTagging from "../../hocs/withTagging";
import {BulkTagAction, BulkUntagAction} from "../Tagging/BulkTagActions";
import {addableTags, removableTags, useTagFilter} from "../../utils/tags";
import {bulkCheckboxColumn, dateColumn, defaultColumn, linkColumn} from "../ContactList/ColumnDefinitions";
import {compose} from "redux";
import {savedSearches, tags} from "../../ducks";
import {truncate} from "../../utils/strings";
import {withRouter} from "react-router";

const columns = [
  linkColumn({
    header: 'Name',
    value: s => truncate(s.name, {length: 115}),
    link: s => `/search/${s.id}`,
  }),
  defaultColumn({
    header: 'Report Type',
    value: 'print_type'
  }),
  dateColumn({
    header: 'Date Created',
    value: 'created_at'
  }),
  defaultColumn({
    header: 'Visibility',
    value: 'visibility'
  }),
  defaultColumn({
    header: 'Owner',
    value: s => <td>{s.owner || 'User deleted'}</td>
  }),
  defaultColumn({
    header: 'Tags',
    value: s => <td><TagList tagNames={s.tag_names}/></td>
  }),
  defaultColumn({
    header: 'Actions',
    value: s => <td>
      <a href={`/searches/${s.id}/edit`} className='open-dialog'>Edit</a>
      {' '}|{' '}
      <a
        data-confirm="Are you sure you wish to delete this search?"
        data-method="delete"
        href={`/searches/${s.id}`}
        rel="nofollow"
      >Delete</a>
    </td>
  })
];

const SavedSearchList = (
  {
    savedSearches: unfilteredSavedSearches,
    tags,

    // withFilter
    filters,
    setFilters,

    // withTagging
    addTags,
    removeTags,
  }
) => {
  const [savedSearches, filterFields] = useTagFilter(unfilteredSavedSearches, {filters, tags});
  filterFields.push({
    solr_prompt: 'name',
    display_name: 'Filter by Name:',
    filter_type: 'TextFilter',
  })
  const bulkContext = useBulkActions(savedSearches)
  const {itemIsSelected, isNoneSelected} = bulkContext;
  const selectedSearches = savedSearches.filter(item => itemIsSelected(item.id));
  const bulkItemDescription = `${selectedSearches.length} selected searches`;

  return <React.Fragment>
    <div className="saved-search-list-header row">
      <PageHeader header="Saved Searches" className="col-12"/>

      <div className="col-12">
        <BulkActions>
          <Edit disabled={isNoneSelected}>
            <BulkTagAction
              itemDescription={bulkItemDescription}
              onSubmit={tags => addTags(selectedSearches, tags)}
              tags={addableTags(tags, selectedSearches)}
            />
            <BulkUntagAction
              itemDescription={bulkItemDescription}
              onSubmit={tags => removeTags(selectedSearches, tags)}
              tags={removableTags(tags, selectedSearches)}
            />
          </Edit>
        </BulkActions>
      </div>
    </div>

    {filterFields.length !== 0 && <Filters
      count={savedSearches.length}
      fields={filterFields}
      selected={filters}
      selectCount={selectedSearches.length}
      submitFilters={setFilters}
      itemsName="Saved Searches"
    />}

    <ContactList
      className="saved-search"
      columns={[
        bulkCheckboxColumn({...bulkContext, value: 'id'}),
        ...columns
      ]}
      contacts={savedSearches}
      emptyMessage="There are no saved searches."
    />
  </React.Fragment>;
};

const mapDucksToProps = ({filters}) => ({
  savedSearches: filterDuck(savedSearches, {filters}),
  tags
});

export default compose(
  withRouter,
  withFiltering,
  withTagging(savedSearches),
  duckify(mapDucksToProps),
)(SavedSearchList);
